import { WhiteLabel } from "./white-label.entity";

export interface RetailerShort {
  id: number;
  name: string;
};
export interface RetailerShortResponse {
  items: RetailerShort[],
  total: number
}

export class Retailer {
  id: number = 0;

  immediate_sim_activation = false;

  manage_sim = true;

  apply_free = true;

  call_low_threshold = 420;

  call_max_threshold = 600;

  spy_sos = false;

  sos_mode = 'full-sos';

  sos_phone: string = null;

  call_directly = false;

  activate_sponsoring = true;

  type = '';

  group = '';

  white_label_id: number;

  constructor(
    public name: string = '',
    public months_free: number = 0,
    public sms_free: number = 0,
    // The white_label field corresponds to the WhiteLabel object built from the `white_label_id` attribute fetched from DB
    // It DOES NOT correspond to the white_label attribute from DB
    // (as of 08/10/19, the white_label attribute is legacy and should be removed)
    public white_label: WhiteLabel = null
  ) {}
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/retailer.entity.ts